
import { systemMessageListAPI } from '@/api/common';
import { crmDownImportErrorAPI } from '@/api/crm/common';

import { downloadExcelWithResData } from '@/utils/index';

export default {
  // 导入历史
  name: 'CRMImportHistory',
  components: {},
  filters: {
    createTime: function createTime(time) {
      var times = time.split(' ');
      return times.length > 0 ? times[0] : '';
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // CRM类型
    crmType: {
      type: String,
      default: ''
    },
    // moduleType
    props: Object
  },
  data: function data() {
    return {
      loading: false,
      tableList: []
    };
  },

  computed: {},
  watch: {
    show: function show(value) {
      if (value) {
        this.getList();
      }
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    getList: function getList() {
      var _this = this;

      this.loading = true;
      systemMessageListAPI({
        page: 1,
        limit: 9999,
        type: {
          customer: 14,
          contacts: 16,
          leads: 18,
          product: 20,
          hrm: 50
        }[this.crmType] || this.props.moduleType
      }).then(function (res) {
        _this.loading = false;
        _this.tableList = res.data.list;
      }).catch(function () {
        _this.loading = false;
      });
    },


    /**
     * 下载错误数据
     */
    downloadError: function downloadError(messageId) {
      crmDownImportErrorAPI({ messageId: messageId }).then(function (res) {
        downloadExcelWithResData(res);
      }).catch(function () {});
    },
    getImportContent: function getImportContent(totalSize, content) {
      var list = content.split(',') || [];
      var updateSize = Number(list[1] || '0');
      var errSize = Number(list[0] || '0');
      return '\u8986\u76D6' + updateSize + '\u6761\uFF0C\u5BFC\u5165\u6210\u529F' + (totalSize - errSize) + '\u6761\uFF0C\u5BFC\u5165\u5931\u8D25' + errSize + '\u6761\u3002';
    },


    /**
     * 获取错误数据数
     */
    getErrorNum: function getErrorNum(content) {
      var list = content.split(',') || [];
      var errSize = Number(list[0] || '0');
      return parseInt(errSize);
    },


    /**
     * 关闭
     */
    closeClick: function closeClick() {
      this.$emit('close');
    }
  }
};